// Core
import { takeEvery } from 'redux-saga/effects';

import { historyActions as actions } from 'bus/history/actions';
import { addViewedHotelWorker, loadViewedHotelsWorker, removeViewedHotelWorker } from './workers';

export const historyWatchers = Object.freeze({
    * addViewedHotelWatcher () {
        yield takeEvery(actions.addViewedHotel, addViewedHotelWorker);
    },
    * removeViewedHotelWatcher () {
        yield takeEvery(actions.removeViewedHotel, removeViewedHotelWorker);
    },
    * loadViewedHotelsWatcher () {
        yield takeEvery(actions.loadViewedHotels, loadViewedHotelsWorker);
    },
});
